import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";
import { FiUserPlus } from "react-icons/fi";
import { AiFillCaretRight } from "react-icons/ai";
import FeedbackContext from "../../context/cmscontext";
import { useContext } from "react";
import Labels from "../../services/apiLabels";
import { SIGN_UP, TOASTER_SHOW, toaster_w } from "../../constant";
import { POST } from "../../constant/apiMethods";
import { scrollTop } from "../../utils/window";
import AuthShell from "../../components/AuthShell/AuthShell";
import "../Login Page/dealers-login.css";

const SIGNUP_VISUAL = "/images/dealers-hero-split.jpg?v=1";

function Signup(props) {
  const { signUp, toasterShow, SIGN_UP_done } = props;
  const history = useHistory();
  const { feedback } = useContext(FeedbackContext);
  const signup_page = feedback.signup_page || {};

  useEffect(() => {
    scrollTop();
  }, []);

  useEffect(() => {
    if (SIGN_UP_done?.token) {
      history.push("/dealers/login");
      SIGN_UP_done.token = "";
    }
  }, [SIGN_UP_done, history]);

  const signUpHandler = (event) => {
    if (event) event.preventDefault();
    const first_name = $("#first_name").val();
    const last_name = $("#last_name").val();
    const email = $("#email").val();
    const username = $("#username").val();
    const password = $("#password").val();
    const data = {
      first_name,
      last_name,
      username,
      password,
      email,
      type: 1,
    };

    if (first_name && last_name && email && username && password) {
      signUp(data);
    } else {
      toasterShow({
        show: true,
        autoHide: false,
        type: toaster_w,
        description: `please enter ${!first_name ? "First Name" : ""}${
          !last_name ? ", Last Name" : ""
        } ${!email ? ", Email Address" : ""} ${
          !username ? ", User Name" : ""
        } ${!password ? ", Password" : ""} & try again`,
      });
    }
  };

  return (
    <AuthShell
      visualImage={SIGNUP_VISUAL}
      visualTitle="Join the dealer"
      visualTitleAccent=" trade floor."
      visualPoints={[
        "Verified dealer access",
        "Auctions & buy now stock",
        "Network sourcing desk",
      ]}
      activeCta="login"
    >
      <div className="dl-panel__inner dl-panel__inner--signup">
        <p className="dl-eyebrow">Dealer registration</p>
        <h1 className="dl-title">{signup_page.signup_text || "Sign up"}</h1>
        <p className="dl-lede">
          Request dealer access to bid, buy wholesale stock, and source across
          the AutoTrade Port network.
        </p>

        <form className="dl-form" onSubmit={signUpHandler} autoComplete="on">
          <div className="dl-field-row">
            <div className="dl-field">
              <label htmlFor="first_name">
                {signup_page.fname_text || "First name"}
              </label>
              <input
                id="first_name"
                type="text"
                className="dl-input"
                placeholder={signup_page.fname_placeholder || "First name"}
                autoComplete="given-name"
              />
            </div>
            <div className="dl-field">
              <label htmlFor="last_name">
                {signup_page.Lname_text || "Last name"}
              </label>
              <input
                id="last_name"
                type="text"
                className="dl-input"
                placeholder={signup_page.Lname_placeholde || "Last name"}
                autoComplete="family-name"
              />
            </div>
          </div>

          <div className="dl-field">
            <label htmlFor="email">
              {signup_page.email_text || "Email address"}
            </label>
            <input
              id="email"
              type="email"
              className="dl-input"
              placeholder={signup_page.email_placeholder || "Enter email"}
              autoComplete="email"
            />
          </div>

          <div className="dl-field">
            <label htmlFor="username">
              {signup_page.userName || "Username"}
            </label>
            <input
              id="username"
              type="text"
              className="dl-input"
              placeholder={signup_page.Uname_placeholder || "Enter username"}
              autoComplete="username"
            />
          </div>

          <div className="dl-field">
            <label htmlFor="password">
              {signup_page.password_signup || "Password"}
            </label>
            <input
              id="password"
              type="password"
              className="dl-input"
              placeholder={
                signup_page.password_signup_placeholder || "Enter password"
              }
              autoComplete="new-password"
            />
          </div>

          <input
            id="remember_me"
            type="checkbox"
            className="dl-sr-only"
            tabIndex={-1}
            aria-hidden="true"
          />

          <button type="submit" className="dl-submit" name="CTAButton">
            <FiUserPlus size={16} aria-hidden />
            {signup_page.register_text || "Register"}
          </button>
        </form>

        <p className="dl-footer-note">
          {signup_page.already_text || "Already have an account?"}{" "}
          <Link to="/dealers/login">
            {signup_page.loginText || "Login"}
            <AiFillCaretRight size={14} aria-hidden />
          </Link>
        </p>
      </div>
    </AuthShell>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  SIGN_UP_done: state.auth.SIGN_UP_done,
});

const mapDispatchToProps = (dispatch) => ({
  signUp: (data) =>
    dispatch({
      type: SIGN_UP,
      payload: { type: SIGN_UP, method: POST, label: Labels.signUp, data },
    }),
  toasterShow: (data) =>
    dispatch({
      type: TOASTER_SHOW,
      payload: {
        ...data,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Signup);
